import { useEffect, useState } from "react";
import { Volume2, Square } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const ListenButton = ({ text, className = "" }) => {
  const { lang } = useLanguage();
  const [playing, setPlaying] = useState(false);

  useEffect(() => () => window.speechSynthesis?.cancel(), []);
  useEffect(() => { setPlaying(false); }, [text]);

  const toggle = () => {
    const synth = window.speechSynthesis;
    if (!synth) return;
    if (playing) {
      synth.cancel();
      setPlaying(false);
      return;
    }
    synth.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = lang.tts;
    const base = lang.tts.split("-")[0];
    const voice = synth.getVoices().find((v) => v.lang === lang.tts) || synth.getVoices().find((v) => v.lang.startsWith(base));
    if (voice) u.voice = voice;
    u.rate = 0.98;
    u.onend = () => setPlaying(false);
    u.onerror = () => setPlaying(false);
    synth.speak(u);
    setPlaying(true);
  };

  return (
    <button
      type="button"
      data-testid="listen-button"
      onClick={toggle}
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-black uppercase tracking-wide transition-all ${
        playing ? "bg-pink-600 text-white shadow-lg shadow-pink-300" : "bg-pink-50 text-pink-700 hover:bg-pink-100"
      } ${className}`}
    >
      {playing ? (
        <>
          <span className="eq-bars" style={{ height: 12 }} aria-hidden="true"><span /><span /><span /><span /><span /></span>
          <Square className="w-3 h-3" /> Stop
        </>
      ) : (
        <>
          <Volume2 className="w-4 h-4" /> Listen to ›
        </>
      )}
    </button>
  );
};

export default ListenButton;
